import { TurnstileInput } from 'hb-react/shared/components/Turnstile/TurnstileInput';
import type { TurnstileInputProps } from 'hb-react/shared/components/Turnstile/TurnstileInput';
import RecaptchaField from 'hb-react/shared/utils/recaptcha';

interface CaptchaFieldProps extends TurnstileInputProps {
  flagEvRecaptchaToTurnstile?: boolean;
}

export const CaptchaFieldInput = ({
  flagEvRecaptchaToTurnstile,
}: CaptchaFieldProps) =>
  flagEvRecaptchaToTurnstile ? (
    <TurnstileInput />
  ) : (
    <RecaptchaField
      onSuccess={undefined}
      error={undefined}
      submitCount={undefined}
    />
  );

export default CaptchaFieldInput;
